import React,{ useState } from "react";
import BlueCartonWithBroom from '~images/oddbods/blue-with-broom.svg';
import Image from "../../../components/loggedout/common/Image";
import { accordionData } from './accordion-data';
import Accordion from './accordion';
import * as S from './style';

const Faq = () => {
  const [accData, setAccData] = useState(accordionData);

  return (
    <S.ContainerWrapper>
      <S.HaveQuesFlexContainer>
        <S.HaveQuesContainer>
          <S.CartonImg>
            <Image alt="image" src={BlueCartonWithBroom} />
          </S.CartonImg>
          <div>
            <S.HaveQuesTitle>Have a question?</S.HaveQuesTitle>
            <S.HaveQuesBody>
              We’d love to hear from you. Write to us at{' '}
              <a href="mailto: help@splashlearn.com">
                <u>help@splashlearn.com</u>
              </a>{' '}
              with all your questions, concerns and feedback.
            </S.HaveQuesBody>
          </div>
        </S.HaveQuesContainer>

        <S.AccordionContainer>
          {accData.map(({ question, answer, openState }, index, accData) => (
            <Accordion
              question={question}
              answer={answer}
              openState={openState}
              setAccData={setAccData}
              index={index}
              key={index}
              accData={accData}
            ></Accordion>
          ))}
        </S.AccordionContainer>
      </S.HaveQuesFlexContainer>
    </S.ContainerWrapper>
  );
}

export default Faq;